export const REQUEST_STORES = 'REQUEST_STORES';
export const RECEIVE_STORES = 'RECEIVE_STORES';
